<template>
  <TemplateModal ref="modal" center width="800" empty>
    <template v-slot:activator>
      <button class="open" @click="onOpenModal" v-if="projects.length">
        <svg
          width="24"
          height="20"
          viewBox="0 0 24 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 4.50001C14.448 4.50001 14 4.05201 14 3.50001V2.00001H10.0001V3.50001C10.0001 4.05201 9.55206 4.50001 9.00006 4.50001C8.44806 4.50001 8.00006 4.05201 8.00006 3.50001V2.00001C8.00006 0.897008 8.89706 7.62939e-06 10.0001 7.62939e-06H14C15.103 7.62939e-06 16 0.897008 16 2.00001V3.50001C16 4.05201 15.552 4.50001 15 4.50001Z"
            fill="#277FAF"
          />
          <path
            d="M12.71 13.38C12.53 13.45 12.27 13.5 12 13.5C11.73 13.5 11.47 13.45 11.23 13.36L0 9.62V17.25C0 18.77 1.23 20 2.75 20H21.25C22.77 20 24 18.77 24 17.25V9.62L12.71 13.38Z"
            fill="#277FAF"
          />
          <path
            d="M24 5.75001V8.04001L12.24 11.96C12.16 11.99 12.08 12 12 12C11.92 12 11.84 11.99 11.76 11.96L0 8.04001V5.75001C0 4.23001 1.23 3.00001 2.75 3.00001H21.25C22.77 3.00001 24 4.23001 24 5.75001Z"
            fill="#277FAF"
          />
        </svg>
        <div class="circle" :data-text="projects.length" />
      </button>
      <div v-else>-</div>
    </template>
    <div class="projects_grid">
      <div
        v-for="(project, key) in projects"
        :key="key"
        class="projects_body"
        @click="deleteId = project.id"
      >
        <router-link
          class="projects_item f16"
          :to="{
            name:
              project.status == 'creating' ||
              project.status == 'bidding' ||
              project.status == 'pending'
                ? 'SalesProjectShow'
                : project.status == 'in_progress'
                ? 'ProjectsProjectShow'
                : project.status == 'done'
                ? 'ProjectsDoneShow'
                : project.status == 'canceled' || project.status == 'intro'
                ? 'SalesArchiveShow'
                : '',
            params: { id: project.id },
          }"
        >
          <svg
            width="24"
            height="20"
            viewBox="0 0 24 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 4.50001C14.448 4.50001 14 4.05201 14 3.50001V2.00001H10.0001V3.50001C10.0001 4.05201 9.55206 4.50001 9.00006 4.50001C8.44806 4.50001 8.00006 4.05201 8.00006 3.50001V2.00001C8.00006 0.897008 8.89706 7.62939e-06 10.0001 7.62939e-06H14C15.103 7.62939e-06 16 0.897008 16 2.00001V3.50001C16 4.05201 15.552 4.50001 15 4.50001Z"
              fill="#277FAF"
            />
            <path
              d="M12.71 13.38C12.53 13.45 12.27 13.5 12 13.5C11.73 13.5 11.47 13.45 11.23 13.36L0 9.62V17.25C0 18.77 1.23 20 2.75 20H21.25C22.77 20 24 18.77 24 17.25V9.62L12.71 13.38Z"
              fill="#277FAF"
            />
            <path
              d="M24 5.75001V8.04001L12.24 11.96C12.16 11.99 12.08 12 12 12C11.92 12 11.84 11.99 11.76 11.96L0 8.04001V5.75001C0 4.23001 1.23 3.00001 2.75 3.00001H21.25C22.77 3.00001 24 4.23001 24 5.75001Z"
              fill="#277FAF"
            />
          </svg>
          <!-- <IconProjectType /> -->
          <div class="projects_item_texts">
            <ProjectStatus :status="project.status" />
            {{ project.name }}
          </div>
        </router-link>
        <DeleteModal
          :text="
            localStorage.translations.pages['sales_project']['planned_resources-subscribers']
              .delete_project +
            ' ' +
            project.name
          "
          :deleteId="project.id"
          :methodDelete="onDeleteSubscribers"
        />
      </div>
    </div>
  </TemplateModal>
</template>

<script>
import TemplateModal from 'components/templates/TemplateModal'
// import IconProjectType from 'components/icons/project/IconProjectType'
import DeleteModal from 'components/DeleteModal'
import ProjectStatus from 'components/project/ProjectStatus'
import { mapActions } from 'vuex'

export default {
  name: 'UserProjectsModal',
  props: {
    projects: {
      type: Array,
      default: () => [],
    },
    onDownloadPageData: Function,
  },
  components: {
    TemplateModal,
    // IconProjectType,
    DeleteModal,
    ProjectStatus,
  },
  data: () => ({
    deleteId: null,
  }),
  computed: {
    modalShow() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
  },
  methods: {
    ...mapActions('workClientProjectsSubscribers', ['onWorkClientProjectsSubscribersDelete']),
    onOpenModal() {
      this.$refs.modal.openModal()
    },
    onDeleteSubscribers(id) {
      this.onWorkClientProjectsSubscribersDelete({ id })
        .then((response) => {
          console.log(response)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.onDownloadPageData()
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.open {
  width: max-content;
  height: max-content;
  position: relative;
  .circle {
    // background: #EBFFF3;
    // background: #f2f2f2;

    // width: 100%;
    position: absolute;
    left: 70%;
    bottom: -10%;
    // padding: 3px;
    // height: max-content;
    // line-height: 1;

    &::before {
      background: #277faf;
      border-radius: 50%;
      min-width: 22px;
      content: attr(data-text);
      // content: '';
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 10px;
      padding: 3px;
      // padding-top: 100%;
      color: #ffffff;
      border-top: 1px solid #f2f2f2;
      border-left: 1px solid #f2f2f2;
    }
  }
}
.projects {
  &_grid {
    width: 100%;
    display: grid;
    gap: 18px;
  }
  &_body {
    display: grid;
    grid-template-columns: 1fr 50px;
    border: 1px solid #277faf;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      background: #277faf;
      :deep().projects_item {
        background: #277faf;
        color: #ffffff;
        svg {
          filter: brightness(0) invert(1);
        }
      }
    }
  }
  &_item {
    background: #ffffff;
    border-radius: 4px;
    width: 100%;
    padding: 15px 25px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #333333;
    transition: 0.3s;
    &_texts {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }
}
</style>
